import { render, staticRenderFns } from "./common-dialog.vue?vue&type=template&id=c0ead206&scoped=true"
import script from "./common-dialog.vue?vue&type=script&lang=js"
export * from "./common-dialog.vue?vue&type=script&lang=js"
import style0 from "./common-dialog.vue?vue&type=style&index=0&id=c0ead206&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ead206",
  null
  
)

export default component.exports